<template>
  <div id="app" :style="{ background: (isHomePage || isCustomServicePage || isProductPage || isProductDetailPage) ? '#000' : '#1a1a1a' }">
    <Header v-if="!isLoginPage" />
    <div class="main-container" :class="{ 'no-header': isLoginPage, 'full-width': isUserCenterPage }">
      <router-view />
    </div>
    <Footer v-if="!isLoginPage" />
    <Sidebar v-if="!isLoginPage" />
  </div>
</template>

<script>
import Header from '@/layout/components/Header'
import Sidebar from '@/layout/components/Sidebar'
import Footer from '@/layout/components/Footer'

export default {
  name: 'App',
  components: {
    Header,
    Sidebar,
    Footer
  },
  computed: {
    isLoginPage() {
      return this.$route.meta.hideNavBar
    },
    isHomePage() {
      return this.$route.path === '/' || this.$route.name === 'HomePage' || this.$route.name === 'Home'
    },
    isCustomServicePage() {
      return this.$route.path === '/custom-service' || this.$route.path.startsWith('/custom-service-detail')
    },
    isProductPage() {
      return this.$route.path === '/product'
    },
    isProductDetailPage() {
      return this.$route.path.startsWith('/product-detail')
    },
    isUserCenterPage() {
      return this.$route.path.startsWith('/user-center') || this.$route.path.startsWith('/topic')
    }
  },
  // vue-meta：把路由 meta.head 同步到 document head
  // 配合预渲染，构建时会把这里的 meta 渲染进静态 HTML
  head() {
    const head = (this.$route && this.$route.meta && this.$route.meta.head) || {}
    return head
  },
  watch: {
    $route: {
      handler(to) {
        // 路由变化时更新 store
        this.$store.dispatch('route/updateRoute', {
          path: to.path,
          name: to.name
        })
      },
      immediate: true
    }
  },
  mounted() {
    // 初始化时获取用户信息
    const token = this.$store.state.user.token
    if (token) {
      this.$store.dispatch('user/getUserInfo')
    }
    // 注入 WebSite + SearchAction 结构化数据，帮助搜索引擎理解站点站内搜索
    this.injectSiteSearchJsonLd()
  },
  methods: {
    injectSiteSearchJsonLd() {
      if (document.getElementById('site-search-jsonld')) return
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.id = 'site-search-jsonld'
      script.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        'name': '点云研智网',
        'url': 'https://pointcloudyzw.com/',
        'description': '专业的3D定制服务与点云数字资产交易平台',
        'potentialAction': {
          '@type': 'SearchAction',
          'target': 'https://pointcloudyzw.com/product?keyword={search_term_string}',
          'query-input': 'required name=search_term_string'
        }
      })
      document.head.appendChild(script)
    }
  }
}
</script>

<style lang="scss">
@import 'remixicon/fonts/remixicon.css';
@import '@/assets/icons/iconfont.css';

body,
html {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}

body {
  font-family: "Microsoft Yahei", "Helvetica Neue", "Helvetica", "Arial", "sans-serif" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -moz-font-feature-settings: "liga", "kern";
  font-feature-settings: "liga", "kern";
  font-size: 14px;
  line-height: normal;
  /* PC 端保持 1250 最小宽度；移动端放开以避免横向滚动条被百度判为移动不友好 */
  min-width: 1250px;

  @media screen and (max-width: 768px) {
    min-width: 100% !important;
    overflow-x: hidden;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  min-height: 100%;
  color: #cbcbcb;
  overflow-x: hidden;

  .main-container {
    max-width: 1800px;
    padding-top: 60px;
    margin: 0 auto;
    width: 100%;
    min-height: calc(100vh - 60px);

    &.no-header {
      max-width: 100%;
      padding: 0;
      margin: 0;
      min-height: 100vh;
    }

    &.full-width {
      max-width: 100%;
      margin: 0;
    }
  }
}

.el-select-dropdown {
  background: #3E3E3E !important;
  border: none !important;

  &__item {
    color: rgba(255, 255, 255, 0.7) !important;

    &.selected,
    &:hover,
    &.hover {
      background-color: transparent !important;
      color: #FFF !important;
    }
  }
}

.el-date-picker {
  background: #3E3E3E !important;
  border: none !important;

  .el-picker-panel__icon-btn {
    color: rgba(255, 255, 255, 0.7) !important;

    &:hover {
      color: #FFF !important;
    }
  }

  &__header {
    &-label {
      color: #FFF !important;
    }
  }

  .el-date-table th {
    color: rgba(255, 255, 255, 0.7) !important;
  }

  .el-date-table {

    td.prev-month,
    td.next-month {
      color: rgba(255, 255, 255, 0.5) !important;
    }

    td.available {
      color: #FFF !important;
    }
  }
}

.popper__arrow::after {
  border-bottom-color: #3E3E3E !important;
  top: 0 !important;
}
</style>
